import React from "react";
import {
  Panel,
  PanelHeader,
  PanelBody,
  MediaBox,
  MediaBoxHeader,
  MediaBoxBody,
  MediaBoxTitle,
  MediaBoxDescription,
  Flex,
  FlexItem,
  Cells,
  Cell,
  CellBody,
  CellFooter,
} from "react-weui";
import axios from "axios";
import { Page } from "../../components";
import "../../css/page/AccountPage.css";
import config from '../../config';

class AccountPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      telephone: null,
      telephone_validate: false,
      isShow: false,
      loginSource: "",
    };

    this.handleBindPhone = this.handleBindPhone.bind(this);
  }
  componentDidMount() {
    document.title = "设置";

    //请求接口判断是否绑定手机
    axios.get("/api/account/personal").then((res) => {
      const account = res.data.data.account;
      const loginSource = {
        wx: "微信",
        weibo: "微博",
        qq: "QQ",
        alipay: "支付宝",
      };
      this.setState({
        init: true,
        telephone: account.telephone.replace(/^(\d{3})\d*(\d{4})$/, "$1****$2"),
        telephone_validate: account.telephone_validate,
        loginSource: loginSource[account.register_source],
      });
    });
  }

  onClickLogout() {
    localStorage.removeItem("_token");
    window.Session.logout(window.location.origin);
  }

  handleBindPhone() {
    //未绑定直接跳转绑定手机页面，已绑定先弹窗
    const { telephone, telephone_validate } = this.state;
    if (telephone_validate) {
      this.setState({
        isShow: true,
      });
      return;
    }
    this.goToBindCellPhone();
  }

  goToBindCellPhone(type) {
    location.assign(
      `/management/bind-cell-phone${type ? "?change=change" : ""}`
    );
  }

  render() {
    const {
      init,
      telephone,
      telephone_validate,
      isShow,
      loginSource,
    } = this.state;
    return (
      <Page>
        <div className="account-setting-page wk-inner-page">
          {init && (
            <div>
              <Cells>
                <Cell onClick={this.handleBindPhone} access href="javascript:;">
                  <CellBody>修改手机号码</CellBody>
                  <CellFooter>
                    {
                      telephone_validate ?
                          <span style={{color:'#8b949c'}}>{telephone}</span>
                          :
                          <span style={{
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#ff5a31'
                          }}>为了您的信息安全，请尽快绑定手机号</span>
                    }
                  </CellFooter>
                </Cell>
              </Cells>
              <Cells>
                <Cell>
                  <CellBody
                    href="javascript:;"
                    className="text-center wk-pointer-hand"
                    onClick={(e) => this.onClickLogout(e)}
                  >
                    退出登录
                  </CellBody>
                </Cell>
              </Cells>
            </div>
          )}
          <div className="platform-agreement">
            <a href={`${config.WK_GW}/secondary/protocol.html`}>
              《荔课平台服务协议》
            </a>
            <a href={`${config.WK_GW}/secondary/privacy.html`}>
              《荔课隐私政策》
            </a>
            <a href={`${config.WK_GW}/secondary/standard.html`}>
              《荔课运营规范》
            </a>
            <a href={`${config.WK_GW}/secondary/guideline.html`}>
              《荔课内容管理规定》
            </a>
            <a href={`${config.WK_GW}/secondary/content_publish.html`}>
              《荔课宣传内容发布规范》
            </a>
            <span> 深圳十方融海科技有限公司 版权所有</span>
          </div>
        </div>
        {isShow && (
          <div className={"bind-phone-alert"}>
            <div className="mask"></div>
            <div className="bind-phone-alert-main">
              <div className="bind-phone-alert-title">更换手机号码？</div>
              <div className={"bind-phone-alert-content"}>
                <p>当前帐号已绑定{loginSource}</p>
                <p>手机号码：{telephone}</p>
              </div>
              <div className="bind-phone-alert-btns">
                <span
                  className="bind-phone-alert-btn-cancel"
                  onClick={() => this.setState({ isShow: false })}
                >
                  取消
                </span>
                <span
                  className="bind-phone-alert-btn-sure"
                  onClick={() => {
                    this.setState({ isShow: false });
                    this.goToBindCellPhone("change");
                  }}
                >
                  确定
                </span>
              </div>
            </div>
          </div>
        )}
      </Page>
    );
  }
}

export default AccountPage;



// WEBPACK FOOTER //
// ./src/pages/AccountPage/AccountSettingPage.js